<template>
  <div class="main-content" id="panel">
      <div class="header bg-primary pb-6">
          <div class="container-fluid">
              <div class="header-body">
              <div class="row align-items-center py-4">
                  <div class="col-lg-5 col-md-12 mb-4">
                    <h2>End Of Day</h2>
                    <div class="ims-tab ml-0">
                      <router-link to="/ims/ims-endofday" class="inv-btn">
                        <button class="btn" v-bind:class="{ 'active': $route.name =='ImsInventoryHoldingList' }" >
                          INVENTORY HOLDINGS
                        </button>
                      </router-link>
                      <router-link to="/ims/ims-endofday/missinginventorylist">
                        <button class="btn" v-bind:class="{ 'active': $route.name =='ImsInventoryMissingList' }" >
                          MISSING INVENTORIES
                        </button>
                      </router-link>
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-12 text-right">
                    
                    <div class="d-inline-flex justify-content-end mt-3">
                      
                      
                      <div class="dropdown">
                        <button :disabled="invUploadStatus == 'INPROGRESS'"
                          class="btn btn-warning rounded dropdown-toggle ml-2 mt-0" type="button"
                          id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                          aria-expanded="false">
                          <div v-if="invUploadStatus == 'INPROGRESS'" style="color:black">
                              <i class="fa fa-spinner fa-spin"></i> IMPORTING..
                          </div>
                          <div v-if="!invUploadStatus">
                              <i class="fas fa-upload"></i> IMPORT
                          </div>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <!-- <a class="dropdown-item cursor-pointer" @click="openImportInventoryModal()">HOLDINGS</a> -->
                            <a class="dropdown-item cursor-pointer"
                                @click="openPositionsModal()">POSITIONS</a>
                            <a class="dropdown-item cursor-pointer"
                                @click="openInventoryCostModal()">INVENTORY COST</a>
                            <!-- <a class="dropdown-item cursor-pointer" @click="openInvAccHoldingModal()">INVENTORY ACCOUNT HOLDINGS</a> -->
                        </div>
                      </div>
                        <div class="dropdown">
                            <button class="btn btn-danger rounded dropdown-toggle ml-2 mt-0" type="button"
                                id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                                <div v-if="exporting">
                                    <i  class="fa fa-spinner fa-spin"></i> EXPORTING...
                          
                                </div>
                                <div v-if="!exporting">
                                    <i  class="fas fa-download"></i> EXPORT
                                </div>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                                <a class="dropdown-item cursor-pointer" @click="exportDataAddToHib()">ADD TO HIB</a>
                                <a class="dropdown-item cursor-pointer" @click="exportDataCostMisMatch()">COST MISMATCH</a>
                                <a class="dropdown-item cursor-pointer" @click="checkAccounts()">INVENTORY SHEET</a>

                            </div>
                        </div>
                        <button @click="openAddInvModal()" type="button"
                          class="btn btn-success rounded"><i class="fas fa-user-plus"></i> ADD
                          NEW</button>

                      </div>
                  </div>
              </div>
              <div style="text-align: right;">
                        <h4 class="text-white" v-if="INVENTORY_COST_FILE_DATE">Latest Inventory Cost File At : {{moment(INVENTORY_COST_FILE_DATE).format("MMMM DD YYYY, h:mm:ss a")}}</h4>
                        <h4 class="text-white" v-if="POSITIONS_FILE_DATE">Latest Position File At : {{moment(POSITIONS_FILE_DATE).format("MMMM DD YYYY, h:mm:ss a")}}</h4>
                      </div>
              <!-- Card stats -->
              </div>
          </div>
      </div>
      <router-view></router-view>
      <ImportPosition v-if="importPositionsModal" @close="openPositionsModal()" />
        <ImportInventoryCost v-if="importInventoryCostModal" @close="openInventoryCostModal()" />
      <addNewInventory v-if="addInvModalOpen" v-bind:selectedInventory="{}" v-bind:mode="'ADD'"
            @close="closeAddInvModal()" />
     
  </div> 
      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import addNewInventory from "../ims-inventory/ImsAddInventoryModal";
import ImportPosition from "../ims-inventory/ImsImportPositionModal"
import ImportInventoryCost from "../ims-inventory/ImsInventoryCostModal"
import Swal from 'sweetalert2';

export default {
name: "imsOfferListComponent",
components : {
  addNewInventory,
  ImportPosition,
  ImportInventoryCost
},
data() {
  return {
    addInvModalOpen : false,
    invUploadStatus : false,
    importPositionsModal: false,
    importInventoryCostModal: false,
    exporting : false,
    INVENTORY_COST_FILE_DATE : "",
    POSITIONS_FILE_DATE : ""


  };
},
methods: {
  arrayToObject(array) {
    return array.reduce((obj, item) => {
      obj[item] = item;
      return obj;
    }, {});
  },
  async checkAccounts() {
    const auth = {
      headers: { 'org-token': authService.getOrgToken() }
    };
    this.$http
      .get(
        config.baseUrlAutoBidder +
        "/excel/list-invaccount",
        auth
      )
      .then(async (res) => {
        if (res.data.length > 1) {
          const { value: acount } = await Swal.fire({
            title: "Please select any inventory account from the list for export",
            input: "select",
            inputOptions: this.arrayToObject(res.data),
            inputPlaceholder: "Select account",
            showCancelButton: true,
          });
          if (acount) {
            this.exportInvSheetData(acount)
          }

        } else {
          this.exportInvSheetData(res.data[0])

        }

      })

  },
  exportInvSheetData(account) {
      this.exporting = true;
      const auth = {
          headers: { 'org-token': authService.getOrgToken() }
      };
      this.$http
          .get(
              config.baseUrlAutoBidder +
              "/excel/inventory-holding?cognitoSub=" + authService.getUser().cognitoSub+"&account="+account,
              auth
          )
          .then((response) => {
              this.exporting = false;
              if (response.data) {
                  window.open(response.data, "_blank");
              }
          }).catch(() => this.exporting = false)

  },
  exportDataAddToHib() {
      this.exporting = true;
      //data.overrideSettlementDate = this.settilementDate ? this.settilementDate : "" ;
      // let fromDate = this.settilementDateFrom ? this.moment(this.settilementDateFrom).format("MM/DD/YYYY")  : "" ;
      // let toDate = this.settilementDateTo ? this.moment(this.settilementDateTo).format("MM/DD/YYYY")  : "" ;
      const auth = {
          headers: { 'org-token': authService.getOrgToken() }
      };
      this.$http
          .get(
              config.baseUrlAutoBidder +
              "/excel/add-to-hib?cognitoSub=" + authService.getUser().cognitoSub,
              auth
          )
          .then((response) => {
              this.exporting = false;
              if (response.data) {
                  window.open(response.data, "_blank");
              }
          }).catch(() => this.exporting = false)

  },
  exportDataCostMisMatch(){
        this.exporting = true;
        //data.overrideSettlementDate = this.settilementDate ? this.settilementDate : "" ;
        // let fromDate = this.settilementDateFrom ? this.moment(this.settilementDateFrom).format("MM/DD/YYYY")  : "" ;
        // let toDate = this.settilementDateTo ? this.moment(this.settilementDateTo).format("MM/DD/YYYY")  : "" ;
         const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/excel/cost-mismatch?cognitoSub="+authService.getUser().cognitoSub,
            auth
        )
        .then((response) => {
            this.exporting = false;
            if(response.data){
                window.open(response.data, "_blank");
            }
        }).catch(() => this.exporting = false)     

    },
  openInventoryCostModal() {
      this.importInventoryCostModal = !this.importInventoryCostModal;

  },
  openPositionsModal() {
      this.importPositionsModal = !this.importPositionsModal;
  },
  openAddInvModal(data) {
      if (data) {
          this.selectedInventory = data;
      }
      this.addInvModalOpen = true;
  },
  closeAddInvModal() {
      this.addInvModalOpen = false;
      // this.getInventoryList();
      this.$root.$emit("refresh",{});
  },
  filelogs(){
        
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlAutoBidder + "/logs/file-upload"+
            "?offset=0&limit=1&fetchLatestCreatedDates=true&fileType=INVENTORY_COST_FILE,POSITIONS_FILE",
            auth
            )
            .then((result) => {
                this.INVENTORY_COST_FILE_DATE = result.data.INVENTORY_COST_FILE;
                this.POSITIONS_FILE_DATE = result.data.POSITIONS_FILE;


            })
            .catch(e => {
            console.log(e);

            });
        }
  
},
mounted() {
  this.filelogs();

 
}
};
</script>
